import React from "react";
import * as style from "./Style";
import * as images from "../../../images";

import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import UploadFileIcon from "@mui/icons-material/UploadFile";

const ImageSection = ({ selectedFiles, setSelectedFiles }) => {
  let arr;
  const changeImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFiles(e.target.files);
    }
  };
  arr = Array.from(selectedFiles);


  return (
    <style.Section>
      <style.CompImage>
        <label htmlFor="upload-photo" style={{ cursor: "pointer" }}>
          <UploadFileIcon sx={{ fontSize: "52px" }} color="info" />
        </label>
      </style.CompImage>
      <style.ImageList>
        {selectedFiles.length !== 0
          ? arr.map((e, i) => {
              if (e.type === "application/pdf") {
                return (
                  <div style={{ textAlign: "center" }}>
                    <DescriptionIcon sx={{ fontSize: "52px" }} color="error" />
                    <p>{e.name}</p>
                  </div>
                );
              } else {
                return <style.Image key={i} src={URL.createObjectURL(e)} />;
              }
            })
          : ""}
      </style.ImageList>

      <input
        type="file"
        id="upload-photo"
        onChange={changeImage}
        style={{ display: "none" }}
        name="files[]"
        multiple
        accept="image/png, image/jpeg, application/pdf"
      />
    </style.Section>
  );
};

export default ImageSection;
